import { PLAN_ROWS } from '../constants/pricing';
import './PlanComparison.css';

function PlanComparison({ variant = 'light', heading = 'Free vs Pro' }) {
  return (
    <div className={`plan-comparison plan-comparison--${variant}`}>
      {heading && <h2 className="plan-comparison__heading">{heading}</h2>}
      <table className="plan-comparison__table">
        <caption className="plan-comparison__caption">
          Compare Free and Pro access to EQ Your Ears.
        </caption>
        <thead>
          <tr>
            <th scope="col">Feature</th>
            <th scope="col">Free</th>
            <th scope="col">Pro</th>
          </tr>
        </thead>
        <tbody>
          {PLAN_ROWS.map((row) => (
            <tr key={row.id}>
              <th scope="row">{row.feature}</th>
              <td>{row.free}</td>
              <td>{row.pro}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PlanComparison;
